import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconAddSvg } from "./IconAddSvg.mjs";
const IconAdd = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconAddSvg, ...iconProps });
};
export {
  IconAdd
};
